module.exports = __webpack_public_path__ + "img/kanagawa.6da31e72.png";